export const services = {
  filterFigments(figments, groups, email) {
    const userGroups = groups
      .filter((i) => i.meta?.userId?.includes('USER#' + email))
      .map(({ pk }) => pk)
    const fArr = figments.filter((f) => {
      if (f?.userId && f.userId.includes(email)) {
        return f
      }
      const found = f?.groupId.some((r) => userGroups.includes(r))
      if (found) {
        return f
      }
    })
    return fArr
  },
  filterSims(hardwareSims, dbSims, groups, email) {
    const userGroups = groups
      .filter((i) => i.meta?.userId?.includes('USER#' + email))
      .map(({ pk }) => pk)
    const hArr = hardwareSims.filter((sim) => {
      const filteredSim = dbSims.filter((s) => s.mtn === sim.mtn)[0]
      if (filteredSim && filteredSim.userId.includes(email)) {
        return sim
      }
      const found = filteredSim?.groupId.some((r) => userGroups.includes(r))
      if (found) {
        return sim
      }
    })
    return hArr
  },
}
